import React from "react";
import { Phone, MessageCircle, MapPin, Mail, Truck } from "lucide-react";
import { BRAND, telHref, waHref, SERVICES } from "../lib/site";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-slate-950 text-slate-300 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-4 md:grid-cols-2 gap-10">
          <div>
            <div className="flex items-center gap-2">
              <span className="w-11 h-11 rounded-xl bg-gradient-to-br from-orange-500 to-red-600 grid place-items-center shadow">
                <Truck className="text-white" size={22} />
              </span>
              <div>
                <div className="text-white font-extrabold tracking-tight" style={{ fontFamily: "Outfit" }}>A SEVEN</div>
                <div className="text-[11px] uppercase tracking-[0.2em] text-orange-400 font-semibold">Packers &amp; Movers</div>
              </div>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-slate-400">
              Delhi NCR ki trusted shifting company. Safe, fast aur professional packing &amp;
              moving services with reasonable pricing.
            </p>
            <div className="mt-5 flex gap-2">
              <a href={telHref} data-testid="footer-call-btn" className="inline-flex items-center gap-1.5 px-3.5 py-2 rounded-full bg-orange-600 hover:bg-orange-700 text-white text-sm font-semibold transition">
                <Phone size={14} /> Call
              </a>
              <a href={waHref()} target="_blank" rel="noreferrer" data-testid="footer-whatsapp-btn" className="inline-flex items-center gap-1.5 px-3.5 py-2 rounded-full bg-[#25D366] hover:bg-[#1ebe57] text-white text-sm font-semibold transition">
                <MessageCircle size={14} /> WhatsApp
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-white font-bold mb-4" style={{ fontFamily: "Outfit" }}>Quick Links</h4>
            <ul className="space-y-2 text-sm">
              {[
                { l: "Home", h: "#home" },
                { l: "About Us", h: "#about" },
                { l: "Services", h: "#services" },
                { l: "Why Choose Us", h: "#why-us" },
                { l: "Gallery", h: "#gallery" },
                { l: "Reviews", h: "#reviews" },
                { l: "Get Free Quote", h: "#quote" },
                { l: "Contact Us", h: "#contact" },
              ].map((q) => (
                <li key={q.l}>
                  <a href={q.h} className="hover:text-orange-400 transition" data-testid={`footer-link-${q.l.toLowerCase().replace(/\s+/g, "-")}`}>
                    {q.l}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-bold mb-4" style={{ fontFamily: "Outfit" }}>Our Services</h4>
            <ul className="space-y-2 text-sm">
              {SERVICES.slice(0, 7).map((s) => (
                <li key={s.title}>
                  <a href="#services" className="hover:text-orange-400 transition">
                    {s.title}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-bold mb-4" style={{ fontFamily: "Outfit" }}>Get in Touch</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex gap-3">
                <MapPin size={18} className="shrink-0 text-orange-400 mt-0.5" />
                <span className="text-slate-300 leading-relaxed">{BRAND.address}</span>
              </li>
              <li className="flex gap-3">
                <Phone size={18} className="shrink-0 text-orange-400 mt-0.5" />
                <a href={telHref} className="hover:text-orange-400">{BRAND.phone}</a>
              </li>
              <li className="flex gap-3">
                <MessageCircle size={18} className="shrink-0 text-orange-400 mt-0.5" />
                <a href={waHref()} target="_blank" rel="noreferrer" className="hover:text-orange-400">
                  WhatsApp: {BRAND.whatsapp}
                </a>
              </li>
              <li className="flex gap-3">
                <Mail size={18} className="shrink-0 text-orange-400 mt-0.5" />
                <a href={`mailto:${BRAND.email}`} className="hover:text-orange-400">{BRAND.email}</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-slate-800 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-slate-500">
          <span>© {new Date().getFullYear()} A Seven Packers and Movers. All rights reserved.</span>
          <span>asevenpackersandmovers · Delhi NCR Shifting Services</span>
        </div>
      </div>
    </footer>
  );
}
